var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M27.5.331c15.005 0 27.169 12.164 27.169 27.169S42.505 54.669 27.5 54.669.331 42.505.331 27.5 12.495.331 27.5.331z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEDFF7",
    fillRule: "nonzero",
    d: "M28.5 1.331c15.005 0 27.169 12.164 27.169 27.169S43.505 55.669 28.5 55.669 1.331 43.505 1.331 28.5 13.495 1.331 28.5 1.331z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EDDDF6",
    fillRule: "nonzero",
    stroke: "#B1A0BB",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B093C2",
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.25 41A4.756 4.756 0 0 1 45 45.75v3.532c.009.53.172 5.966.183 9.834v.612C45.182 61.617 45.134 63 45 63L27.75 50a.75.75 0 0 1-.75-.75v-3.5A4.756 4.756 0 0 1 31.75 41h8.5zM36 29a5 5 0 1 1 0 10 5 5 0 0 1 0-10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EEDFF7",
    d: "M26.93 37.929c1.768 0 3.374.705 4.556 1.85a6.607 6.607 0 0 1 2.01 4.519h0l.004 15.08c-.564.233-.807.271-1.15.305-.488.047-1.208.089-2.093.123-1.935.075-4.67.117-7.51.127h0l-.638.001H20.89l-.638-.001c-5.499-.019-10.435-.322-10.635-.568h0L9.5 44.535c0-1.776.7-3.39 1.838-4.579a6.535 6.535 0 0 1 4.495-2.023h0l11.097-.004zM21.5 22.5c1.903 0 3.625.776 4.872 2.03a6.927 6.927 0 0 1 2.017 4.899c0 1.913-.77 3.644-2.017 4.898a6.848 6.848 0 0 1-4.872 2.03 6.848 6.848 0 0 1-4.872-2.03 6.927 6.927 0 0 1-2.017-4.898c0-1.913.77-3.645 2.017-4.899A6.848 6.848 0 0 1 21.5 22.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarGroup);
export default __webpack_public_path__ + "static/media/avatarGroup.dbc5d7cd9e1bf6da7f4e9b7f549c3628.svg";
export { ForwardRef as ReactComponent };